import * as axios from 'axios';
import {
  BaseURL
} from './config';

const getImpacts = async function () {

  try {
    const response = await axios.get(`${BaseURL}/impact/`);

    if (response.status !== 200) throw Error(response.message);
    if (!response.data) return [];
    let list = response.data;
    if (typeof list !== 'object') {
      list = [];
    }
    return list;

  } catch (error) {
    console.error(error);
    return [];
  }
};

const getImpactReportById = async function (id) {

  try {
    const response = await axios.get(`${BaseURL}/impact/` + id);

    if (response.status !== 200) throw Error(response.message);
    if (!response.data) return [];
    let list = response.data;
    if (typeof list !== 'object') {
      list = [];
    }
    return list;

  } catch (error) {
    console.error(error);
    return error;
  }
};

const getInvestments = async function () {

  try {

    const response = await axios.get(`${BaseURL}/investment/`);

    if (response.status !== 200) throw Error(response.message);
    if (!response.data) return [];
    let list = response.data;
    if (typeof list !== 'object') {
      list = [];
    }
    return list;

  } catch (error) {
    console.error(error);
    return [];
  }
};

const getInvestmentsReportById = async function (id) {

  try {
    const response = await axios.get(`${BaseURL}/investment/` + id);

    if (response.status !== 200) throw Error(response.message);
    if (!response.data) return [];
    let list = response.data;
    if (typeof list !== 'object') {
      list = [];
    }
    return list;

  } catch (error) {
    console.error(error);
    return error;
  }
};

const getStories = async function () {

  try {

    const response = await axios.get(`${BaseURL}/stories/`);

    if (response.status !== 200) throw Error(response.message);
    if (!response.data) return [];
    let list = response.data;
    if (typeof list !== 'object') {
      list = [];
    }
    return list;

  } catch (error) {
    console.error(error);
    return [];
  }
};

const getStoryById = async function (id) {

  try {
    const response = await axios.get(`${BaseURL}/stories/` + id);

    if (response.status !== 200) throw Error(response);
    if (!response.data) return [];
    let list = response.data;
    if (typeof list !== 'object') {
      list = [];
    }
    return list;

  } catch (error) {
    console.error(error);
    return error;
  }
};
const parseList = response => {
  if (response.status !== 200) throw Error(response.message);
  if (!response.data) return [];
  let list = response.data;
  if (typeof list !== 'object') {
    list = [];
  }
  return list;
};

export const data = {
  getInvestments,
  getInvestmentsReportById,
  getImpacts,
  getImpactReportById,
  getStoryById,
  getStories
};